export enum ECartApiUrl {
  cart = '/api/carts',
  cartItem = '/api/carts/offers',
  multiCart = '/api/carts',
  paymentVariants = '/api/carts/payment',
}
